import React from "react";
import { Table, Empty, Tag, Switch } from "antd";
import "./style.scss";
import { serialNum } from "../../utils";

function ServiceabilityListTable({
  loading,
  tableData,
  pageSize,
  totalCount,
  currentPage,
  handlePageChange,
  handleBookingOnlyToggle,
  handleActiveToggle,
}) {
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const renderServiceTypeTags = (data) => {
    return (
      <div className="service-tags-container">
        {data.vayuquick && (
          <Tag className="service-tag vayuquick-tag">VayuQuick</Tag>
        )}

        {data.vayuquickPro && (
          <Tag className="service-tag vayuquick-pro-tag">VayuQuick Pro</Tag>
        )}

        {!data.vayuquick && !data.vayuquickPro && (
          <span className="no-tag">None</span>
        )}
      </div>
    );
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      key: "slNo",
      dataIndex: "slNo",
      width: 80,
      render: (a, b, idx) => serialNum(pageSize, currentPage, idx),
    },
    {
      title: "From Pincode",
      dataIndex: "fromPincode",
      key: "fromPincode",
      width: 100,
    },
    {
      title: "From City",
      dataIndex: "fromCity",
      key: "fromCity",
      width: 100,
    },
    {
      title: "From State",
      dataIndex: "fromState",
      key: "fromState",
      width: 100,
    },
    {
      title: "To Pincode",
      dataIndex: "toPincode",
      key: "toPincode",
      width: 100,
    },
    {
      title: "To City",
      dataIndex: "toCity",
      key: "toCity",
      width: 100,
    },
    {
      title: "To State",
      dataIndex: "toState",
      key: "toState",
      width: 100,
    },
    {
      title: "Tag",
      dataIndex: "tag",
      key: "tag",
      width: 160,
      render: (_, record) => renderServiceTypeTags(record),
    },
    {
      title: "Booking Only",
      dataIndex: "isBookingOnly",
      key: "isBookingOnly",
      width: 80,
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) => handleBookingOnlyToggle(checked, record)}
          size="small"
        />
      ),
    },
    {
      title: "VQ Enabled",
      dataIndex: "isActive",
      key: "isActive",
      width: 80,
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) => handleActiveToggle(checked, record)}
          size="small"
          loading={loading}
        />
      ),
    },
  ];

  return (
    <div className="serviceability-table-container">
      <div className="table-header">
        <h3>Existing Serviceability Routes</h3>
      </div>
      <Table
        className="serviceability-table"
        columns={columns}
        dataSource={tableData}
        onChange={handlePageChange}
        loading={loading}
        defaultCurrent={1}
        pagination={{
          pageSize: pageSize,
          total: totalCount,
          current: currentPage,
          showSizeChanger: true,
          itemRender: itemRender,
        }}
        scroll={{ x: 1200, y: 400 }}
        size="middle"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No serviceability data"
            />
          ),
        }}
      />
    </div>
  );
}

export default ServiceabilityListTable;
